import LogRequestForHelpWidgetModel from "./LogRequestForHelpWidgetModel";
import AskQuestionWidgetModel from "./AskQuestionWidgetModel";
import PickLanguageWidgetModel from "./PickLanguageWidgetModel";
import SendMessageWidgetModel from "./SendMessageWidgetModel";

export default class IVRFlowConfigurationModel {
	public pickLanguageWidgetDetail: PickLanguageWidgetModel | null;
	public logRequestForHelpWidgetDetail: LogRequestForHelpWidgetModel | null;
	public sendMessageWidgetDetail: SendMessageWidgetModel[];
	public askQuestionWidgetDetail: AskQuestionWidgetModel[];

	public constructor() {
		this.pickLanguageWidgetDetail = null;
		this.logRequestForHelpWidgetDetail = null;
		this.sendMessageWidgetDetail = [];
		this.askQuestionWidgetDetail = [];
	}
}
